module.exports = __webpack_public_path__ + "bf58d4bf8f25f85fa42c4234a5fa50a9.jpg";